/**
 * initDrawer — wire up open/close behaviour for a <dialog> drawer.
 *
 * Convention:
 *   - Open trigger: any element with [data-open-drawer="<dialog-id>"]
 *   - Close trigger: any element inside the dialog with [data-close-drawer]
 *   - Clicking the backdrop (the <dialog> element itself) also closes it.
 *   - Escape key is handled natively by the browser.
 *
 * @param {HTMLDialogElement} dialog
 */
export function initDrawer(dialog) {
  if (!dialog) return;

  document
    .querySelectorAll(`[data-open-drawer="${dialog.id}"]`)
    .forEach((btn) => btn.addEventListener('click', () => dialog.showModal()));

  dialog
    .querySelectorAll('[data-close-drawer]')
    .forEach((btn) => btn.addEventListener('click', () => dialog.close()));

  dialog.addEventListener('click', (e) => {
    if (e.target === dialog) dialog.close();
  });
}
